class Gradient {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.ui.$panels.forEach((panel) => {
      panel.removeEventListener('mouseover', this.onMouseOver.bind(this));
      panel.removeEventListener('mouseout', this.onMouseOut.bind(this));
    });
  }

  bindUI() {
    this.ui = {};
    this.body = document.body;
    this.doc = document.documentElement;
    if (this.doc.getAttribute('data-useragent')) {
      this.isFirefox = document.documentElement.dataset.useragent.includes('Firefox');
    }
    this.ui.$panels = [...this.element.querySelectorAll('[data-ref="panel"]')];
  }

  bindEvents() {
    this.ui.$panels.forEach((panel) => {
      panel.addEventListener('mouseover', this.onMouseOver.bind(this));
      panel.addEventListener('mouseout', this.onMouseOut.bind(this));
    });
  }

  onMouseOver(e) {
    const target = e.currentTarget;
    const color = target.getAttribute('data-gradient');

    target.parentNode.classList.add(`gradient-home--${color}`);

    // fallback for firefox which doesn't support css :has yet
    // if (this.isFirefox) {
    // }
    this.body.classList.add('panel-hovered');
  }

  onMouseOut(e) {
    const target = e.currentTarget;
    const color = target.getAttribute('data-gradient');

    document.activeElement.blur();
    target.parentNode.classList.remove(`gradient-home--${color}`);

    // fallback for firefox which doesn't support css :has yet
    // if (this.isFirefox) {
    // }
    this.body.classList.remove('panel-hovered');
  }
}

export default Gradient;
